import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext, useMemo } from 'react';
const InternalErrorContext = createContext(undefined);
export const useInternalError = () => {
    const context = useContext(InternalErrorContext);
    if (!context) {
        throw new Error('useInternalError must be used within a InternalErrorProvider');
    }
    return context;
};
export const InternalErrorProvider = ({ children }) => {
    const [errorOcurred, setErrorOcurred] = useState(false);
    const contextValue = useMemo(() => ({ errorOcurred, setErrorOcurred }), [errorOcurred, setErrorOcurred]);
    return (_jsx(InternalErrorContext.Provider, { value: contextValue, children: children }));
};
